<template>
  <div>
    <h2>You are entering surveys for {{ location.name }}</h2>
    <br>
    <h2>To begin, enter your PIN code</h2>
    <br>
    <label>PIN: {{ location.code.toUpperCase() }} -</label>
    <input type="text" v-model="userPinCode">
    &nbsp;
    <b-button size="lg" @click="start">Start Survey</b-button>

    <div v-show="showErr">
      <b-alert show dismissible>No results match your search</b-alert>
    </div>

    <div>
      <b-button size="lg">Cancel</b-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "surveyPin",
  data: () => ({
    location: {},
    userPinCode: "",
    showErr: false
  }),
  methods: {
    loadLocation(id) {
      this.axios
        .get(process.env.VUE_APP_API_URL + "locations/" + id)
        .then(response => {
          this.location = response.data;
          //this.$emit("onLoad", this.location.name);
        })
        .catch(error => console.log(error));
    },
    start() {
      this.axios
        .get("volunteers/findbycode/" + this.userPinCode)
        .then(res => {
          if (res.data)
            this.$router.push({
              name: "surveyStep1",
              params: { locId: this.location.id, volId: res.data.id }
            });
          else this.showErr = true;
        })
        .catch(error => console.log(error));
    }
  },
  mounted() {
    this.loadLocation(this.$route.params.locId);
  }
};
</script>
